import { render, staticRenderFns } from "./PayoutModal.vue?vue&type=template&id=16708c8d&"
import script from "./PayoutModal.vue?vue&type=script&lang=js&"
export * from "./PayoutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports